import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const analyticsExternalRoutes = [
	{
		key: "analytics-external",
		exact: true,
		path: `${APP_PREFIX_PATH}/analytics/external`,
		component: React.lazy(() => import("views/analytics-views/dashboards/sub-dashboards/external/pages/ExternalPage")),
	},
];
